import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user } = useContext(AuthContext);

    if (!user) return <Navigate to="/" />;

    // ❌ NOT ALLOWED ROLE
    if (roles && !roles.includes(user.role)) {
        // ✅ SAFE ROLE-BASED REDIRECT
        if (user.role === "FIELD_TECH") {
            return <Navigate to="/tasks" />;
        }

        if (user.role === "POS_TECHNICIAN") {
            return <Navigate to="/pos/tickets" />;
        }

        if (user.role === "OFFICE_TECH") {
            return <Navigate to="/repair-warranty" />;
        }

        if (user.role === "INVENTORY_ADMIN") {
            return <Navigate to="/dashboard" />;
        }

        // default (admin roles)
        return <Navigate to="/dashboard" />;
    }

    return children;
}
